interface checkboxProps {
  name?: string;
  label: string;
  value: boolean;
  onChangeCheckbox: (checked: boolean) => void;
}

const Checkbox = (props: checkboxProps) => {
  const { label, value, onChangeCheckbox } = props;
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeCheckbox(event.target.checked);
  };

  return (
    <label className="w-full flex justify-start items-center gap-x-2">
      {label}
      <input
        className=" w-4 h-4 !text-mobasher-green bg-gray-100 border-gray-300 rounded !focus:ring-mobasher-green dark:focus:ring-green-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
        type="checkbox"
        checked={value}
        onChange={handleCheckboxChange}
      />
    </label>
  );
};

export default Checkbox;
